import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    API_URL: 'https://bzqz5u6q28.execute-api.us-east-1.amazonaws.com/u1',
    redirectURL: 'https://arap.qc.ap.alight.com',
    externalCognitoTokenURL: "https://arap-qc-ext.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoTokenURL: "https://arap-qc-int.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoAuthorizeURL: "https://arap-qc-int.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    sso_external_client_id: 'a8ghqo393ss8j3h8lm07kuf1q',
    sso_internal_client_id: '2g3ok8653qoehodtuni373m2bp',
    sso_api_pwd: '',
    identityPoolId: "us-east-1:5a94ac10-de9a-43d2-ba4b-c4dbc2267669",
    showAIButton: true,
    chatEnabled: true,
    chatClientCodes: [],
    chatAllowedUserIdSubstrings: [],
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    rumApplicationId: '2b551c41-e16e-40a1-b846-c4ddaaa981f4',
    websocketUrl: 'wss://eg4yh2y19l.execute-api.us-east-1.amazonaws.com/qc',
    useApiMock: false,
    quicksightEmbedBaseUrl: "https://us-east-1.quicksight.aws.amazon.com/embed/",
};
